"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

import HeroButton from "@/components/site/sections/widgets/HeroButton";
import PhoneNumberInput from "./PhoneNumberInput";
import { useCookie } from "@/hooks/useCookie";
import { track } from "@/lib/track";

export function HeroCta() {
  const router = useRouter();
  const [phoneNumber, setPhoneNumber] = useState("");
  const cookieHasNickname = !!useCookie("nickname");

  return (
    <>
      {!cookieHasNickname ? (
        <PhoneNumberInput
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
        />
      ) : null}
      <HeroButton
        cookieHasNickname={cookieHasNickname}
        onClick={() => {
          track("landing_page_quick_start");
          router.push(
            cookieHasNickname
              ? "/papers"
              : phoneNumber
                ? `/login?phone=${phoneNumber}`
                : "/login",
          );
        }}
      />
    </>
  );
}
